import { toggleDetails, toggleInformation, togglePerformancePage, toggleSidebars } from '../actions/index.js'

let _depth = 0           // number of history entries we have pushed
let _suppress = 0        // counts pending history.back() calls we initiated (counter beats boolean against unrelated popstate events)
let _fromPopstate = false // prevents middleware re-entry from popstate-dispatched actions
let _listenerRegistered = false // guard against registering popstate listener multiple times

const getElementDisplay = (state) => state.getIn(['ui', 'elementDisplay'])

const sidebarHistoryMiddleware = store => {

    if (!_listenerRegistered) {
        _listenerRegistered = true
        window.addEventListener('popstate', () => {
            if (_suppress > 0) {
                _suppress--
                return
            }
            if (_depth <= 0) return

            _depth--

            const el = getElementDisplay(store.getState())
            const sidebarRightSecondOpen = el.get('displaySidebarRightSecond')
            const sidebarRightOpen = el.get('displaySidebarRight')

            _fromPopstate = true

            if (sidebarRightSecondOpen) {
                store.dispatch(toggleSidebars('right', 2, false))
                if (el.get('performancePageOpen')) {
                    store.dispatch(togglePerformancePage(false, false))
                }
                if (el.get('activeDetailsItem')) {
                    store.dispatch(toggleDetails(false))
                }
            } else if (sidebarRightOpen) {
                store.dispatch(toggleSidebars('right', 1, false))
                // popstate path must clear information state explicitly;
                // UI-initiated closes handle this in their own dispatch chain
                store.dispatch(toggleInformation(false, false))
                if (el.get('activeDetailsItem')) {
                    store.dispatch(toggleDetails(false))
                }
            }
            // else: neither overlay open (resize edge case) — depth decremented, nothing dispatched

            _fromPopstate = false
        })
    }

    return next => action => {
        if (_fromPopstate) return next(action)

        if (action.type === 'UI_TOGGLE_SIDEBARS') {
            const { side, int, bool } = action.payload

            if (side === 'right') {
                const el = getElementDisplay(store.getState())
                const key = int === 1 ? 'displaySidebarRight' : 'displaySidebarRightSecond'
                const currentlyOpen = el.get(key)

                if (bool === true && !currentlyOpen) {
                    _depth++
                    window.history.pushState({ pmkSidebar: int, depth: _depth }, '', window.location.href)
                } else if (bool === false && currentlyOpen && _depth > 0) {
                    _suppress++
                    _depth--
                    window.history.back()
                }
            }
        }

        return next(action)
    }
}

export default sidebarHistoryMiddleware
